import React from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import TableEditor from './TableEditor';
import GuestListPage from './GuestListPage';
import AdminClients from './AdminClients';
import AdminSettings from './AdminSettings';
import ProtectedRoute from '../components/ProtectedRoute';
import { getStoredUser, clearSession } from '../api';

export default function AdminDashboard() {
  const user = getStoredUser();
  const navigate = useNavigate();

  function logout() {
    clearSession();
    navigate('/admin/login');
  }

  return (
    <div className="admin-shell">
      <aside className="admin-nav">
        <h2 className="admin-brand">
          {user?.role === 'admin' ? 'Paneli i Adminit' : (user?.full_name || 'Paneli i Dasmës')}
        </h2>

        {user?.role === 'admin' && (
          <NavLink to="/admin/clients" className={({ isActive }) => (isActive ? 'active' : '')}>
            👥 Klientët
          </NavLink>
        )}

        {user?.role === 'client' && (
          <>
            <NavLink to="/admin/skica" className={({ isActive }) => (isActive ? 'active' : '')}>
              🪑 Skica e Sallës
            </NavLink>
            <NavLink to="/admin/mysafire" className={({ isActive }) => (isActive ? 'active' : '')}>
              👥 Lista e Mysafirëve
            </NavLink>
            <NavLink to="/admin/cilesimet" className={({ isActive }) => (isActive ? 'active' : '')}>
              ⚙️ Cilësimet &amp; QR
            </NavLink>
          </>
        )}

        <button className="logout-btn" onClick={logout}>⎋ Dil</button>
      </aside>
      <main className="admin-content">
        <Routes>
          <Route index element={<Navigate to={user?.role === 'admin' ? 'clients' : 'skica'} replace />} />

          <Route path="clients" element={
            <ProtectedRoute requiredRole="admin"><AdminClients /></ProtectedRoute>
          } />

          <Route path="skica" element={
            <ProtectedRoute requiredRole="client"><TableEditor /></ProtectedRoute>
          } />
          <Route path="mysafire" element={
            <ProtectedRoute requiredRole="client"><GuestListPage /></ProtectedRoute>
          } />
          <Route path="cilesimet" element={
            <ProtectedRoute requiredRole="client"><AdminSettings /></ProtectedRoute>
          } />
        </Routes>
      </main>
    </div>
  );
}
